import { PersonIdentifierViewModel, PersonIdentifierCreateCommand, PersonIdentifierUpdateCommand } from '../../models/Entities/Person/Identifier/PersonIdentifierModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_IDENTIFIER_GETALL_REQUEST = 'PERSON_IDENTIFIER_GETALL_REQUEST';
export const PERSON_IDENTIFIER_GETALL_SUCCESS = 'PERSON_IDENTIFIER_GETALL_SUCCESS';
export const PERSON_IDENTIFIER_GETALL_FAILURE = 'PERSON_IDENTIFIER_GETALL_FAILURE';

export interface PersonIdentifierGetAllRequestAction {
    type: typeof PERSON_IDENTIFIER_GETALL_REQUEST;
    personId: number;
}

export interface PersonIdentifierGetAllSuccessAction {
    type: typeof PERSON_IDENTIFIER_GETALL_SUCCESS;
    personId: number;
    payload: PersonIdentifierViewModel[];
}

export interface PersonIdentifierGetAllFailureAction {
    type: typeof PERSON_IDENTIFIER_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_GETBYID_REQUEST = 'PERSON_IDENTIFIER_GETBYID_REQUEST';
export const PERSON_IDENTIFIER_GETBYID_SUCCESS = 'PERSON_IDENTIFIER_GETBYID_SUCCESS';
export const PERSON_IDENTIFIER_GETBYID_FAILURE = 'PERSON_IDENTIFIER_GETBYID_FAILURE';

export interface PersonIdentifierGetByIdRequestAction {
    type: typeof PERSON_IDENTIFIER_GETBYID_REQUEST;
    id: number;
}

export interface PersonIdentifierGetByIdSuccessAction {
    type: typeof PERSON_IDENTIFIER_GETBYID_SUCCESS;
    payload: PersonIdentifierViewModel;
}

export interface PersonIdentifierGetByIdFailureAction {
    type: typeof PERSON_IDENTIFIER_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_CREATE_REQUEST = 'PERSON_IDENTIFIER_CREATE_REQUEST';
export const PERSON_IDENTIFIER_CREATE_SUCCESS = 'PERSON_IDENTIFIER_CREATE_SUCCESS';
export const PERSON_IDENTIFIER_CREATE_FAILURE = 'PERSON_IDENTIFIER_CREATE_FAILURE';

export interface PersonIdentifierCreateRequestAction {
    type: typeof PERSON_IDENTIFIER_CREATE_REQUEST;
    payload: PersonIdentifierCreateCommand;
}

export interface PersonIdentifierCreateSuccessAction {
    type: typeof PERSON_IDENTIFIER_CREATE_SUCCESS;
    payload: PersonIdentifierViewModel;
}

export interface PersonIdentifierCreateFailureAction {
    type: typeof PERSON_IDENTIFIER_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_UPDATE_REQUEST = 'PERSON_IDENTIFIER_UPDATE_REQUEST';
export const PERSON_IDENTIFIER_UPDATE_SUCCESS = 'PERSON_IDENTIFIER_UPDATE_SUCCESS';
export const PERSON_IDENTIFIER_UPDATE_FAILURE = 'PERSON_IDENTIFIER_UPDATE_FAILURE';

export interface PersonIdentifierUpdateRequestAction {
    type: typeof PERSON_IDENTIFIER_UPDATE_REQUEST;
    payload: PersonIdentifierUpdateCommand;
}

export interface PersonIdentifierUpdateSuccessAction {
    type: typeof PERSON_IDENTIFIER_UPDATE_SUCCESS;
    payload: PersonIdentifierViewModel;
}

export interface PersonIdentifierUpdateFailureAction {
    type: typeof PERSON_IDENTIFIER_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_IDENTIFIER_DELETE_REQUEST = 'PERSON_IDENTIFIER_DELETE_REQUEST';
export const PERSON_IDENTIFIER_DELETE_SUCCESS = 'PERSON_IDENTIFIER_DELETE_SUCCESS';
export const PERSON_IDENTIFIER_DELETE_FAILURE = 'PERSON_IDENTIFIER_DELETE_FAILURE';

export interface PersonIdentifierDeleteRequestAction {
    type: typeof PERSON_IDENTIFIER_DELETE_REQUEST;
    id: number;
}

export interface PersonIdentifierDeleteSuccessAction {
    type: typeof PERSON_IDENTIFIER_DELETE_SUCCESS;
    id: number;
}

export interface PersonIdentifierDeleteFailureAction {
    type: typeof PERSON_IDENTIFIER_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}

// identifier availability verification
export const PERSON_IDENTIFIER_VERIFY_REQUEST = 'PERSON_IDENTIFIER_VERIFY_REQUEST';
export const PERSON_IDENTIFIER_VERIFY_SUCCESS = 'PERSON_IDENTIFIER_VERIFY_SUCCESS';
export const PERSON_IDENTIFIER_VERIFY_FAILURE = 'PERSON_IDENTIFIER_VERIFY_FAILURE';
export const PERSON_IDENTIFIER_VERIFY_RESET = 'PERSON_IDENTIFIER_VERIFY_RESET';

export interface PersonIdentifierVerifyRequestAction {
    type: typeof PERSON_IDENTIFIER_VERIFY_REQUEST;
}

export interface PersonIdentifierVerifySuccessAction {
    type: typeof PERSON_IDENTIFIER_VERIFY_SUCCESS;
    payload: boolean;
}

export interface PersonIdentifierVerifyFailureAction {
    type: typeof PERSON_IDENTIFIER_VERIFY_FAILURE;
    error: ErrorType;
}

export interface PersonIdentifierVerifyResetAction {
    type: typeof PERSON_IDENTIFIER_VERIFY_RESET;
}
